var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogleplayBadge = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Lager 1",
  viewBox: "0 0 135 40"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 21.73,
  x2: 4.95,
  y1: 33.12,
  y2: 16.33,
  gradientTransform: "matrix(1 0 0 -1 0 42)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#00a0ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#00a1ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#00beff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#00d2ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#00dfff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00e3ff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 33.76,
  x2: 9.57,
  y1: 21.82,
  y2: 21.82,
  gradientTransform: "matrix(1 0 0 -1 0 42)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ffe000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.41,
  stopColor: "#ffbd00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "orange"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ff9c00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: 24.76,
  x2: 2,
  y1: 19.53,
  y2: -3.23,
  gradientTransform: "matrix(1 0 0 -1 0 42)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ff3a44"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#c31162"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: 7.23,
  x2: 17.39,
  y1: 41.65,
  y2: 31.49,
  gradientTransform: "matrix(1 0 0 -1 0 42)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#32a071"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.07,
  stopColor: "#2da771"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#15cf74"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#06e775"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00f076"
})))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 135,
  height: 40,
  x: -0.07,
  y: 0.17,
  rx: 5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#a6a6a6",
  d: "M129.93 1a4.21 4.21 0 0 1 4.2 4.2v30a4.21 4.21 0 0 1-4.2 4.2h-125a4.2 4.2 0 0 1-4.2-4.2v-30A4.21 4.21 0 0 1 4.93 1zm0-.8h-125a5 5 0 0 0-5 5v30a5 5 0 0 0 5 5h125a5 5 0 0 0 5-5v-30a5 5 0 0 0-5-5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.2,
  d: "M47.35 10.42a2.7 2.7 0 0 1-.75 2 2.9 2.9 0 0 1-2.2.89 3.09 3.09 0 0 1-3.12-3.14A3.09 3.09 0 0 1 44.4 7a3 3 0 0 1 1.23.25 2.54 2.54 0 0 1 .94.67l-.57.57a2 2 0 0 0-1.64-.71 2.31 2.31 0 0 0-2.33 2.39 2.3 2.3 0 0 0 .69 1.73 2.27 2.27 0 0 0 1.64.67 2.24 2.24 0 0 0 1.67-.67 1.93 1.93 0 0 0 .51-1.22H44.4V10h2.9a2.5 2.5 0 0 1 .05.42zM52 7.91h-2.78v1.9h2.47v.72h-2.47v1.91H52v.73h-3.55v-6H52zm3.21 5.26h-.77V7.91h-1.68v-.74h4.12v.74h-1.67zm4.66 0v-6h.77v6zm4.19 0h-.77V7.91h-1.68v-.74h4.12v.74h-1.67zm9.48-.77a3.11 3.11 0 0 1-4.4 0 3.1 3.1 0 0 1-.89-2.23A3.08 3.08 0 0 1 69.14 8a3.1 3.1 0 0 1 4.39 0 3 3 0 0 1 .89 2.22 3.08 3.08 0 0 1-.88 2.18zm-3.83-.5a2.32 2.32 0 0 0 3.26 0 2.38 2.38 0 0 0 .66-1.73A2.37 2.37 0 0 0 73 8.45a2.32 2.32 0 0 0-3.26 0 2.34 2.34 0 0 0-.74 1.72 2.34 2.34 0 0 0 .71 1.73zm5.79 1.27v-6h.94l2.92 4.67V7.17h.77v6h-.81l-3-4.89v4.89z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M68.06 21.93a4.25 4.25 0 1 0 4.27 4.25 4.18 4.18 0 0 0-4.27-4.25m0 6.83a2.59 2.59 0 1 1 2.4-2.58 2.47 2.47 0 0 1-2.4 2.58m-9.31-6.83A4.25 4.25 0 1 0 63 26.18a4.19 4.19 0 0 0-4.25-4.25m0 6.83a2.59 2.59 0 1 1 2.4-2.58 2.46 2.46 0 0 1-2.4 2.58m-11.08-5.53V25H52a3.83 3.83 0 0 1-1 2.28 4.46 4.46 0 0 1-3.34 1.32 4.8 4.8 0 0 1 0-9.6 4.63 4.63 0 0 1 3.26 1.28L52.2 19a6.3 6.3 0 0 0-4.53-1.82 6.61 6.61 0 1 0 0 13.21 6 6 0 0 0 4.61-1.85 6 6 0 0 0 1.56-4.22 6.3 6.3 0 0 0-.09-1.13zM93 24.63a3.94 3.94 0 0 0-3.64-2.7 4 4 0 0 0-4 4.25 4.16 4.16 0 0 0 4.22 4.25 4.21 4.21 0 0 0 3.54-1.88l-1.45-1a2.42 2.42 0 0 1-2.09 1.18 2.16 2.16 0 0 1-2.06-1.29l5.68-2.35zm-5.8 1.42a2.33 2.33 0 0 1 2.22-2.48 1.64 1.64 0 0 1 1.58.9zm-4.62 4.12h1.87v-12.5h-1.89zm-3.08-7.29h-.07a2.94 2.94 0 0 0-2.24-.95 4.25 4.25 0 0 0 0 8.5 2.91 2.91 0 0 0 2.24-1h.07v.61a2.18 2.18 0 0 1-2.28 2.49 2.35 2.35 0 0 1-2.14-1.51l-1.63.68a4.07 4.07 0 0 0 3.77 2.51c2.2 0 4-1.29 4-4.43v-7.6H79.5zm-2.15 5.88A2.44 2.44 0 0 1 75 26.19a2.45 2.45 0 0 1 2.36-2.59 2.39 2.39 0 0 1 2.27 2.59 2.37 2.37 0 0 1-2.28 2.57m24.38-11.09h-4.47v12.5h1.87v-4.73h2.6a3.89 3.89 0 1 0 0-7.77m0 6h-2.6v-4.26h2.65a2.15 2.15 0 1 1 0 4.29zm11.53-1.8a3.51 3.51 0 0 0-3.26 1.95l1.66.69a1.78 1.78 0 0 1 1.71-.92 1.8 1.8 0 0 1 2 1.61v.13a4.2 4.2 0 0 0-2-.48c-1.78 0-3.6 1-3.6 2.81a2.89 2.89 0 0 0 3.1 2.75 2.62 2.62 0 0 0 2.38-1.22h.07v1h1.8v-4.83c-.01-2.22-1.67-3.46-3.81-3.46zm-.22 6.85c-.61 0-1.46-.3-1.46-1.06 0-1 1.06-1.33 2-1.33a3.26 3.26 0 0 1 1.71.42 2.26 2.26 0 0 1-2.2 2zm10.58-6.57-2.14 5.42h-.06l-2.22-5.42h-2l3.33 7.57-1.86 4.28h2l5.13-11.78zm-16.81 8h1.87V17.67h-1.87z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "M10.36 7.71a2 2 0 0 0-.46 1.41v22.11a2 2 0 0 0 .46 1.41l.08.07 12.39-12.39V20L10.44 7.64z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#b)",
  d: "m27 24.45-4.13-4.13V20L27 15.9h.09l4.89 2.78c1.4.8 1.4 2.09 0 2.89l-4.93 2.83z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#c)",
  d: "m27.05 24.4-4.22-4.23-12.47 12.47a1.62 1.62 0 0 0 2.08.06z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#d)",
  d: "M27.05 16 12.44 7.65a1.62 1.62 0 0 0-2.08.06l12.47 12.46z"
})), /*#__PURE__*/React.createElement("path", {
  d: "m27 24.31-14.56 8.24a1.66 1.66 0 0 1-2 0l-.08.08.08.07a1.66 1.66 0 0 0 2 0l14.61-8.3z",
  opacity: 0.2,
  style: {
    isolation: "isolate"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.36 32.49a2 2 0 0 1-.46-1.4v.14a2 2 0 0 0 .46 1.41l.08-.08zm21.58-11.02-5 2.84.09.09 4.89-2.78A1.76 1.76 0 0 0 33 20.18a1.85 1.85 0 0 1-1.06 1.29",
  opacity: 0.12,
  style: {
    isolation: "isolate"
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m12.44 7.8 19.5 11.08A1.85 1.85 0 0 1 33 20.17a1.76 1.76 0 0 0-1.05-1.44L12.44 7.65C11 6.86 9.9 7.52 9.9 9.12v.14C9.9 7.66 11 7 12.44 7.8",
  opacity: 0.25,
  style: {
    isolation: "isolate"
  }
}));
export { SvgGoogleplayBadge as ReactComponent };